<template>
  <Section
    class="home"
    ref="home"
    background="fill-4"
    v-observe-visibility="intObseverCfg"
    slanted-bottom
    :slanted="-1"
    viewport-height
  >
    <div class="vertical-text">Come swim with us _</div>
    <transition name="slide-down">
      <div class="header" v-if="showHeader">
        <Logo class="header__logo" />
        <Menu class="header__menu" />
      </div>
    </transition>
    <transition name="fade">
      <div v-show="showParticles" class="particles">
        <img ref="particles" src="@/assets/img/ball.png" />
      </div>
    </transition>
    <transition name="slide-up">
      <h1 v-if="showTagline" class="tagline">
        <span>Hi, we're</span>
        <img src="@/assets/img/orca_logo_white.svg" />
        <span>labs</span>
      </h1>
    </transition>
    <transition name="slide-up">
      <div v-if="showHeader" class="scroll-down">
        <router-link :to="{ path: '#about', query: { scroll: true } }">
          <img height="40" src="@/assets/img/chevron-down.svg" />
        </router-link>
      </div>
    </transition>
  </Section>
</template>

<script>
import '@/utils/canvas/nextparticle.js';
import Menu from '@/components/Menu.vue';
import Logo from '@/components/Logo.vue';
import { mapState } from 'vuex';

export default {
  name: 'Home',

  components: {
    Menu,
    Logo,
  },

  data() {
    return {
      particles: null,
      showTagline: false,
      showParticles: false,
      showHeader: false,
      intObseverCfg: {
        callback: this.setTopic,
        intersection: {
          rootMargin: '-200px',
        },
      },
    };
  },

  computed: mapState(['isScrolling']),

  methods: {
    setTopic: function (isVisible) {
      if (isVisible && !this.isScrolling) {
        this.$router.push({ path: '#home', query: { scroll: false } });
      }
    },
    handleScroll: function (event) {
      let top = window.innerHeight - event.pageY;
      if (top < 0) return;
      this.$refs.home.$el.style.opacity = window.scrollY > window.innerHeight / 2 ? (top * 2) / window.innerHeight : 1;
    },
    handleResize: function (event) {
      console.log('resize');
      this.particles.width = window.innerWidth / 2;
      this.particles.height = window.innerHeight;
      this.particles.start();
    },
  },

  mounted() {
    // eslint-disable-next-line
    this.particles = new NextParticle({
      image: this.$refs.particles,
      particleGap: '6',
      noise: '20',
    });

    setTimeout(() => {
      this.showHeader = true;
    }, 400);
    setTimeout(() => {
      this.showParticles = true;
    }, 600);
    setTimeout(() => {
      this.showTagline = true;
    }, 200);

    window.addEventListener('scroll', this.handleScroll);
  },

  destroyed: function () {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.home {
  color: #fff;
}

.vertical-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  position: absolute;
  font-weight: 500;
  right: 30px;
  bottom: 40px;
  display: none;
  @include font-size(15px);

  @include respond-to('small') {
    display: block;
  }
}

.scroll-down {
  position: absolute;
  left: 50%;
  bottom: 60px;
  transform: translateX(-50%);
  border-radius: 500px;
  transition: background-color 0.4s;
  background-color: rgba($--color--fill-3, 0.15);

  &:hover {
    background-color: rgba($--color--fill-3, 0.5);
  }

  a {
    padding: 10px;
    display: block;
    outline: 0;
  }

  @include respond-to('small') {
    bottom: 40px;
  }
}

.header {
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  @include respond-to('small') {
    padding: 30px 40px;
  }

  &__menu {
    margin-left: auto;
  }
}

.particles {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: none;

  @include respond-to('small') {
    display: block;
  }
}

.tagline {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  font-family: $--font--secondary;
  font-weight: 200;
  text-align: center;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  @include font-size(50px);

  img {
    height: 50px;
    margin: 14px;
  }

  @include respond-to('small') {
    white-space: nowrap;
    @include font-size(65px);
  }

  strong {
    font-weight: 600;
  }
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.5s $--ease-pattern;
}

.slide-down-enter,
.slide-down-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.5s $--ease-pattern;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translate(-50%, 20px);
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 2s $--ease-pattern;
}

.fade-leave-active {
  transition: opacity 0.2s $--ease-pattern;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
